/* UNITO Anywhere — interaktiv app-prototype i iPhone-ramme.
   Ren vanilla-port af React-komponenterne IOSDevice (ios-frame.jsx) og
   AnywhereApp (anywhere.jsx): Home, Cold Water, Hot Water, Soda Settings,
   Faucet Settings og System Status — med målere, skydere og localStorage. */
(function () {
  'use strict';

  var C = {
    bg: '#0E1C2B', bgTop: '#13263A', white: '#FFFFFF',
    mute: 'rgba(255,255,255,0.55)', faint: 'rgba(255,255,255,0.30)',
    hair: 'rgba(255,255,255,0.10)', track: 'rgba(255,255,255,0.09)',
    cold: '#2C6BF6', hot: '#E4452A', sodaA: '#E8D24A', sodaB: '#2BA65E',
    needle: '#E8A23C', blue: '#2C6BF6', card: 'rgba(255,255,255,0.045)',
  };
  var FONT = "-apple-system, 'SF Pro Display', system-ui, sans-serif";

  /* ---------- ikoner (1:1 fra anywhere.jsx I) ---------- */
  function I(name, size, color, sw) {
    size = size || 22; color = color || '#fff'; sw = sw || 1.7;
    var p = 'fill="none" stroke="' + color + '" stroke-width="' + sw + '" stroke-linecap="round" stroke-linejoin="round"';
    var paths = {
      chevron: '<path d="M15 5l-7 7 7 7" ' + p + '/>',
      minus: '<path d="M6 12h12" ' + p + '/>',
      plus: '<path d="M12 6v12M6 12h12" ' + p + '/>',
      snow: '<g ' + p + '><path d="M12 3v18M5 7l14 10M19 7L5 17"/><path d="M12 3l-2.4 2.4M12 3l2.4 2.4M12 21l-2.4-2.4M12 21l2.4-2.4"/></g>',
      thermo: '<g ' + p + '><path d="M14 14.5V5a2 2 0 0 0-4 0v9.5a4 4 0 1 0 4 0z"/><path d="M12 9v6.5"/></g>',
      glass: '<g ' + p + '><path d="M6 4h12l-1.2 15.2a1 1 0 0 1-1 .8H8.2a1 1 0 0 1-1-.8L6 4z"/><path d="M6.6 9.5h10.8"/></g>',
      cart: '<g ' + p + '><circle cx="9" cy="20" r="1.4" fill="' + color + '" stroke="none"/><circle cx="18" cy="20" r="1.4" fill="' + color + '" stroke="none"/><path d="M2.5 3h2.2l2.1 11.2a1.5 1.5 0 0 0 1.5 1.2h8.4a1.5 1.5 0 0 0 1.5-1.2L21 6H6"/></g>',
      drop: '<path d="M12 3s6 6.6 6 10.8A6 6 0 0 1 6 13.8C6 9.6 12 3 12 3z" ' + p + '/>',
      gear: '<g ' + p + '><circle cx="12" cy="12" r="3.2"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5 5l2.1 2.1M16.9 16.9 19 19M19 5l-2.1 2.1M7.1 16.9 5 19"/></g>',
      pulse: '<path d="M3 12h4l2.5-7 5 14 2.5-7H21" ' + p + '/>',
      check: '<path d="M5 12.5l4.5 4.5L19 7" ' + p + '/>',
    };
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" style="display:block">' + (paths[name] || '') + '</svg>';
  }

  /* ---------- tilstand ---------- */
  var DEFAULTS = {
    cold: 5, hot: 100, soda: 2,
    autofillMode: 'Double click', autofillSec: 25,
    flushMode: 'Sparkle', flushSec: 1.6,
  };
  var SODA_LEVELS = [
    { label: 'LIGHT', frac: 0.16 },
    { label: 'MEDIUM', frac: 0.5 },
    { label: 'INTENSE', frac: 0.84 },
  ];

  function loadState() {
    var s = {};
    for (var k in DEFAULTS) s[k] = DEFAULTS[k];
    try {
      var saved = JSON.parse(localStorage.getItem('unito-app') || '{}');
      for (var j in saved) if (j in DEFAULTS) s[j] = saved[j];
    } catch (e) {}
    if (s.cold < 5) s.cold = 5;
    s.cart = { co2: false, filter: false, desinfekt: false };
    return s;
  }
  function persist(state) {
    try {
      var out = {};
      for (var k in state) if (k !== 'cart') out[k] = state[k];
      localStorage.setItem('unito-app', JSON.stringify(out));
    } catch (e) {}
  }

  /* ---------- SVG-byggesten ---------- */
  function arcGauge(frac, color, size, stroke) {
    size = size || 250; stroke = stroke || 9;
    var r = size / 2 - stroke - 2, cx = size / 2, cy = size / 2;
    var circ = 2 * Math.PI * r, arc = 0.75 * circ;
    var prog = Math.max(0, Math.min(1, frac)) * arc;
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + ' ' + size + '" style="display:block">' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="' + C.track + '" stroke-width="' + stroke + '" stroke-linecap="round" stroke-dasharray="' + arc + ' ' + circ + '" transform="rotate(135 ' + cx + ' ' + cy + ')"/>' +
      '<circle data-g-prog data-g-circ="' + circ + '" data-g-arc="' + arc + '" cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="' + color + '" stroke-width="' + stroke + '" stroke-linecap="round" stroke-dasharray="' + prog + ' ' + circ + '" transform="rotate(135 ' + cx + ' ' + cy + ')" style="transition:stroke-dasharray 480ms cubic-bezier(.4,0,.2,1);filter:drop-shadow(0 0 7px ' + color + '66)"/>' +
      '</svg>';
  }
  function tempReadout(value) {
    return '<div style="display:flex;align-items:flex-start;color:' + C.white + '">' +
      '<span data-g-val style="font-size:78px;font-weight:200;line-height:1;letter-spacing:-2px;font-family:' + FONT + '">' + value + '</span>' +
      '<span style="font-size:22px;font-weight:300;margin-top:10px;margin-left:3px;color:' + C.mute + '">°C</span></div>';
  }
  function roundBtn(iconName, dir, disabled) {
    return '<button type="button" data-step="' + dir + '" ' + (disabled ? 'disabled' : '') + ' style="width:56px;height:56px;border-radius:50%;background:transparent;border:1.5px solid ' + (disabled ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.28)') + ';display:grid;place-items:center;cursor:' + (disabled ? 'default' : 'pointer') + ';opacity:' + (disabled ? '0.4' : '1') + ';transition:all 150ms;-webkit-tap-highlight-color:transparent">' + I(iconName, 22, C.white, 2) + '</button>';
  }
  function head(title, withBack) {
    return '<div style="position:relative;display:flex;align-items:center;justify-content:center;height:30px;margin-bottom:6px">' +
      (withBack ? '<button type="button" data-back style="position:absolute;left:0;top:0;height:30px;display:flex;align-items:center;gap:2px;background:none;border:none;cursor:pointer;color:' + C.white + ';padding:0;-webkit-tap-highlight-color:transparent">' + I('chevron', 20, C.white, 2.2) + '<span style="font-size:15px;font-weight:400">Back</span></button>' : '') +
      '<span style="font-size:13px;font-weight:600;letter-spacing:1.6px;color:' + C.white + ';text-transform:uppercase">' + title + '</span></div>';
  }
  function shell(inner, scroll) {
    return '<div style="height:100%;box-sizing:border-box;padding:58px 22px 30px;display:flex;flex-direction:column;overflow-y:' + (scroll ? 'auto' : 'hidden') + ';animation:scrIn 320ms cubic-bezier(.32,.72,0,1)">' + inner + '</div>';
  }

  function sodaGauge(frac, size) {
    size = size || 250;
    var r = size / 2 - 14, cx = size / 2, cy = size / 2;
    var circ = 2 * Math.PI * r, arc = 0.75 * circ;
    var ang = 135 + frac * 270, rad = ang * Math.PI / 180;
    var nx = cx + (r - 6) * Math.cos(rad), ny = cy + (r - 6) * Math.sin(rad);
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + ' ' + size + '">' +
      '<defs><linearGradient id="sodaGrad" x1="0" y1="1" x2="1" y2="0"><stop offset="0" stop-color="' + C.sodaA + '"/><stop offset="0.5" stop-color="#9FC94F"/><stop offset="1" stop-color="' + C.sodaB + '"/></linearGradient></defs>' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="' + C.track + '" stroke-width="9" stroke-linecap="round" stroke-dasharray="' + arc + ' ' + circ + '" transform="rotate(135 ' + cx + ' ' + cy + ')"/>' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="url(#sodaGrad)" stroke-width="9" stroke-linecap="round" stroke-dasharray="' + arc + ' ' + circ + '" transform="rotate(135 ' + cx + ' ' + cy + ')"/>' +
      '<line data-needle data-r="' + (r - 6) + '" data-cx="' + cx + '" data-cy="' + cy + '" x1="' + cx + '" y1="' + cy + '" x2="' + nx + '" y2="' + ny + '" stroke="' + C.needle + '" stroke-width="4" stroke-linecap="round" style="transition:all 480ms cubic-bezier(.4,0,.2,1)"/>' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="9" fill="' + C.needle + '"/><circle cx="' + cx + '" cy="' + cy + '" r="4" fill="' + C.bg + '"/></svg>';
  }

  /* ---------- glyffer til System Status ---------- */
  function co2Cylinder(level) {
    var top = 64, bottom = 150, h = bottom - top;
    var fillY = bottom - h * (level == null ? 0.62 : level);
    var marks = [['F', 44], ['M', 90], ['E', 136]].map(function (m) {
      return '<line x1="44" y1="' + m[1] + '" x2="49" y2="' + m[1] + '" stroke="' + C.faint + '" stroke-width="1.4"/><text x="52" y="' + (m[1] + 4) + '" fill="' + C.mute + '" font-size="11" font-family="' + FONT + '" text-anchor="start">' + m[0] + '</text>';
    }).join('');
    return '<svg width="54" height="160" viewBox="0 0 54 160">' +
      '<rect x="22" y="6" width="10" height="12" rx="2" fill="rgba(255,255,255,0.35)"/>' +
      '<rect x="18" y="16" width="18" height="10" rx="3" fill="rgba(255,255,255,0.5)"/>' +
      '<rect x="12" y="26" width="30" height="128" rx="15" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.3)" stroke-width="1.6"/>' +
      '<clipPath id="uaCyl"><rect x="12" y="26" width="30" height="128" rx="15"/></clipPath>' +
      '<g clip-path="url(#uaCyl)"><rect x="12" y="' + fillY + '" width="30" height="' + (bottom - fillY + 10) + '" fill="#5B8DF8" opacity="0.5"/></g>' + marks + '</svg>';
  }
  function filterGlyph(pct) {
    return '<svg width="48" height="120" viewBox="0 0 48 120">' +
      '<rect x="14" y="6" width="20" height="10" rx="2" fill="rgba(255,255,255,0.4)"/>' +
      '<path d="M12 16h24v86a14 14 0 0 1-14 14h0a14 14 0 0 1-14-14V16z" transform="translate(2 0)" fill="rgba(91,141,248,0.12)" stroke="rgba(255,255,255,0.3)" stroke-width="1.5"/>' +
      '<text x="24" y="74" fill="' + C.white + '" font-size="13" font-weight="600" font-family="' + FONT + '" text-anchor="middle">' + (pct == null ? 99 : pct) + '%</text></svg>';
  }
  function bottleGlyph() {
    return '<svg width="44" height="120" viewBox="0 0 44 120">' +
      '<rect x="17" y="6" width="10" height="14" rx="2" fill="rgba(255,255,255,0.4)"/>' +
      '<path d="M14 20h16v14l4 8v46a8 8 0 0 1-8 8H18a8 8 0 0 1-8-8V42l4-8V20z" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.3)" stroke-width="1.5"/></svg>';
  }
  function faucetGlyphMini(color) {
    color = color || 'rgba(44,107,246,0.5)';
    return '<svg width="40" height="56" viewBox="0 0 40 56" fill="none">' +
      '<path d="M8 6v14a8 8 0 0 0 8 8h10" stroke="' + color + '" stroke-width="2.4" stroke-linecap="round"/>' +
      '<rect x="4" y="3" width="8" height="5" rx="1.5" fill="' + color + '"/>' +
      '<path d="M26 28v4" stroke="' + color + '" stroke-width="2.4" stroke-linecap="round"/>' +
      '<path d="M22 40c0-3 4-8 4-8s4 5 4 8a4 4 0 1 1-8 0z" stroke="' + color + '" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  /* ---------- iPhone-ramme (IOSDevice, dark) ---------- */
  function frameHTML() {
    var c = '#fff';
    var statusBar = '<div style="position:absolute;top:0;left:0;right:0;z-index:10"><div style="display:flex;align-items:center;justify-content:center;padding:21px 24px 19px;box-sizing:border-box;position:relative;z-index:20;width:100%">' +
      '<div style="flex:1;height:22px;display:flex;align-items:center;justify-content:center;padding-top:1.5px"><span style="font-family:-apple-system,\'SF Pro\',system-ui;font-weight:590;font-size:17px;line-height:22px;color:' + c + '">9:41</span></div>' +
      '<div style="flex:1;height:22px;display:flex;align-items:center;justify-content:center;gap:7px;padding-top:1px;padding-right:1px">' +
      '<svg width="19" height="12" viewBox="0 0 19 12"><rect x="0" y="7.5" width="3.2" height="4.5" rx="0.7" fill="' + c + '"/><rect x="4.8" y="5" width="3.2" height="7" rx="0.7" fill="' + c + '"/><rect x="9.6" y="2.5" width="3.2" height="9.5" rx="0.7" fill="' + c + '"/><rect x="14.4" y="0" width="3.2" height="12" rx="0.7" fill="' + c + '"/></svg>' +
      '<svg width="17" height="12" viewBox="0 0 17 12"><path d="M8.5 3.2C10.8 3.2 12.9 4.1 14.4 5.6L15.5 4.5C13.7 2.7 11.2 1.5 8.5 1.5C5.8 1.5 3.3 2.7 1.5 4.5L2.6 5.6C4.1 4.1 6.2 3.2 8.5 3.2Z" fill="' + c + '"/><path d="M8.5 6.8C9.9 6.8 11.1 7.3 12 8.2L13.1 7.1C11.8 5.9 10.2 5.1 8.5 5.1C6.8 5.1 5.2 5.9 3.9 7.1L5 8.2C5.9 7.3 7.1 6.8 8.5 6.8Z" fill="' + c + '"/><circle cx="8.5" cy="10.5" r="1.5" fill="' + c + '"/></svg>' +
      '<svg width="27" height="13" viewBox="0 0 27 13"><rect x="0.5" y="0.5" width="23" height="12" rx="3.5" stroke="' + c + '" stroke-opacity="0.35" fill="none"/><rect x="2" y="2" width="20" height="9" rx="2" fill="' + c + '"/><path d="M25 4.5V8.5C25.8 8.2 26.5 7.2 26.5 6.5C26.5 5.8 25.8 4.8 25 4.5Z" fill="' + c + '" fill-opacity="0.4"/></svg>' +
      '</div></div></div>';
    return '<div style="width:372px;height:806px;border-radius:48px;overflow:hidden;position:relative;isolation:isolate;background:#000;box-shadow:0 40px 80px rgba(0,0,0,0.18),0 0 0 1px rgba(0,0,0,0.12);font-family:-apple-system,system-ui,sans-serif;-webkit-font-smoothing:antialiased;flex-shrink:0">' +
      '<div style="position:absolute;top:11px;left:50%;transform:translateX(-50%);width:126px;height:37px;border-radius:24px;background:#000;z-index:50"></div>' +
      statusBar +
      '<div style="height:100%;display:flex;flex-direction:column"><div data-anywhere-app style="flex:1;overflow:auto;position:relative;background:radial-gradient(120% 80% at 50% 0%, ' + C.bgTop + ' 0%, ' + C.bg + ' 55%)"></div></div>' +
      '<div style="position:absolute;bottom:0;left:0;right:0;z-index:60;height:34px;display:flex;justify-content:center;align-items:flex-end;padding-bottom:8px;pointer-events:none"><div style="width:139px;height:5px;border-radius:100px;background:rgba(255,255,255,0.7)"></div></div>' +
      '</div>';
  }

  /* ---------- skærme ---------- */
  function homeHTML(state) {
    function tile(title, value, sub, color, iconName, target) {
      return '<button type="button" data-go="' + target + '" style="text-align:left;border:none;cursor:pointer;border-radius:22px;padding:18px;background:' + C.card + ';position:relative;overflow:hidden;display:flex;flex-direction:column;min-height:116px;-webkit-tap-highlight-color:transparent;font-family:' + FONT + '">' +
        '<div style="position:absolute;top:-30px;right:-30px;width:90px;height:90px;border-radius:50%;background:' + color + ';opacity:0.16;filter:blur(8px)"></div>' +
        '<div style="width:38px;height:38px;border-radius:11px;background:' + color + '26;display:grid;place-items:center;margin-bottom:auto">' + I(iconName, 20, color) + '</div>' +
        '<div style="color:' + C.mute + ';font-size:12.5px;margin-top:14px">' + title + '</div>' +
        '<div style="color:' + C.white + ';font-size:20px;font-weight:500;margin-top:1px">' + value + '<span style="font-size:12px;color:' + C.mute + ';font-weight:400;margin-left:4px">' + sub + '</span></div></button>';
    }
    function listLink(iconName, title, sub, target) {
      return '<button type="button" data-go="' + target + '" style="width:100%;text-align:left;border:none;cursor:pointer;background:' + C.card + ';border-radius:18px;padding:15px 16px;display:flex;align-items:center;gap:14px;-webkit-tap-highlight-color:transparent;font-family:' + FONT + '">' +
        '<div style="width:38px;height:38px;border-radius:11px;background:rgba(255,255,255,0.06);display:grid;place-items:center;flex-shrink:0">' + I(iconName, 19, C.white) + '</div>' +
        '<div style="flex:1"><div style="color:' + C.white + ';font-size:15.5px;font-weight:500">' + title + '</div><div style="color:' + C.faint + ';font-size:12.5px;margin-top:1px">' + sub + '</div></div>' +
        '<span style="display:inline-flex;transform:scaleX(-1)">' + I('chevron', 17, C.faint, 2) + '</span></button>';
    }
    return shell(
      '<div style="padding-top:6px">' +
      '<div style="display:flex;align-items:center;gap:8px;margin-bottom:4px"><span style="width:7px;height:7px;border-radius:50%;background:' + C.sodaB + ';box-shadow:0 0 8px ' + C.sodaB + '"></span><span style="color:' + C.mute + ';font-size:12.5px;white-space:nowrap">UNITO Infinity+ · Køkken</span></div>' +
      '<div style="color:' + C.white + ';font-size:30px;font-weight:600;letter-spacing:-0.5px;margin-bottom:2px">UNITO Anywhere</div>' +
      '<div style="color:' + C.faint + ';font-size:13.5px;margin-bottom:22px">Alt dit vand — styret fra ét sted.</div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:12px">' +
      tile('Kogende', state.hot, '°C', C.hot, 'thermo', 'hot') +
      tile('Koldt', state.cold, '°C', C.cold, 'snow', 'cold') +
      tile('Brusvand', SODA_LEVELS[state.soda].label, '', C.sodaB, 'glass', 'soda') +
      tile('Filtreret', 'Til', '', '#7BB8D1', 'drop', 'cold') +
      '</div>' +
      '<div style="display:flex;flex-direction:column;gap:10px;margin-top:8px">' +
      listLink('gear', 'Faucet Settings', 'Autofill & flush-timer', 'faucet') +
      listLink('pulse', 'System Status', 'CO₂ · filter · desinfektion', 'status') +
      '</div></div>', true);
  }

  function tempScreenHTML(kind, state) {
    var isCold = kind === 'cold';
    var v = isCold ? state.cold : state.hot;
    var min = isCold ? 5 : 60, max = isCold ? 12 : 100;
    var frac = isCold ? (max - v) / (max - min) : (v - min) / (max - min);
    var footer = isCold
      ? '<div style="display:flex;align-items:center;justify-content:center;gap:14px;color:' + C.faint + ';padding-bottom:6px">' + I('thermo', 26, C.faint) + I('snow', 24, C.faint) + '</div>'
      : '<div style="display:flex;align-items:center;justify-content:center;gap:8px;color:' + C.faint + ';padding-bottom:6px">' + I('thermo', 26, C.faint) + '<span data-foot-val style="font-size:13px;color:' + C.faint + '">' + v + '°</span></div>';
    return shell(
      head(isCold ? 'Cold Water' : 'Hot Water', true) +
      '<div style="flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:30px">' +
      '<div style="position:relative;width:250px;height:250px">' + arcGauge(frac, isCold ? C.cold : C.hot) +
      '<div style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center">' + tempReadout(v) + '</div></div>' +
      '<div style="display:flex;gap:48px;align-items:center">' + roundBtn('minus', -1, v <= min) + roundBtn('plus', 1, v >= max) + '</div>' +
      '</div>' + footer, false);
  }

  function sodaHTML(state) {
    var cur = SODA_LEVELS[state.soda];
    return shell(
      head('Soda Settings', true) +
      '<div style="flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:22px">' +
      '<div style="position:relative;width:250px;height:250px">' + sodaGauge(cur.frac) +
      '<div data-soda-label style="position:absolute;left:0;right:0;bottom:64px;text-align:center;color:' + C.white + ';font-size:15px;font-weight:600;letter-spacing:2px">' + cur.label + '</div></div>' +
      '<div style="display:flex;gap:48px;align-items:center">' + roundBtn('minus', -1, state.soda <= 0) + roundBtn('plus', 1, state.soda >= 2) + '</div>' +
      '</div>' +
      '<div style="display:flex;align-items:center;justify-content:center;padding-bottom:6px">' + I('glass', 28, C.faint) + '</div>', false);
  }

  function segmented(options, value, key) {
    return '<div style="display:inline-flex;background:rgba(255,255,255,0.06);border-radius:11px;padding:3px;gap:3px" data-seg="' + key + '">' +
      options.map(function (o) {
        var on = o === value;
        return '<button type="button" data-seg-val="' + o + '" style="padding:8px 16px;border-radius:9px;border:none;cursor:pointer;font-size:13.5px;font-weight:500;font-family:' + FONT + ';background:' + (on ? C.blue : 'transparent') + ';color:' + (on ? '#fff' : C.mute) + ';transition:all 160ms;-webkit-tap-highlight-color:transparent">' + o + '</button>';
      }).join('') + '</div>';
  }
  function slider(value, min, max, step, key, suffix) {
    var frac = (value - min) / (max - min);
    return '<div style="width:100%" data-slider="' + key + '" data-min="' + min + '" data-max="' + max + '">' +
      '<div data-slider-val style="text-align:center;color:' + C.white + ';font-size:22px;font-weight:300;margin-bottom:14px">' + value + '<span style="font-size:14px;color:' + C.mute + ';margin-left:4px">' + suffix + '</span></div>' +
      '<input type="range" class="unito-range" min="' + min + '" max="' + max + '" step="' + step + '" value="' + value + '" style="width:100%;height:4px;border-radius:4px;background:linear-gradient(90deg,' + C.blue + ' ' + (frac * 100) + '%,rgba(255,255,255,0.14) ' + (frac * 100) + '%);outline:none;cursor:pointer">' +
      '<div style="display:flex;justify-content:space-between;margin-top:8px;color:' + C.faint + ';font-size:12px"><span>' + min + '</span><span>' + max + '</span></div></div>';
  }

  function faucetHTML(state) {
    return shell(
      head('Faucet Settings', true) +
      '<div style="padding-top:8px;display:flex;flex-direction:column;gap:26px">' +
      '<div><div style="color:' + C.mute + ';font-size:12px;font-weight:600;letter-spacing:1.4px;margin-bottom:12px">AUTOFILL TIMER</div>' +
      '<div style="display:flex;justify-content:center;margin-bottom:18px">' + segmented(['Double click', 'Single click'], state.autofillMode, 'autofillMode') + '</div>' +
      '<div style="display:flex;align-items:center;gap:16px">' + faucetGlyphMini() + '<div style="flex:1">' + slider(state.autofillSec, 4, 60, 1, 'autofillSec', 'sec') + '</div></div></div>' +
      '<div style="height:1px;background:' + C.hair + '"></div>' +
      '<div><div style="color:' + C.mute + ';font-size:12px;font-weight:600;letter-spacing:1.4px;margin-bottom:12px">FLUSH TIMER</div>' +
      '<div style="display:flex;justify-content:center;margin-bottom:18px">' + segmented(['Boiling', 'Sparkle'], state.flushMode, 'flushMode') + '</div>' +
      '<div style="display:flex;align-items:center;gap:16px">' + faucetGlyphMini('rgba(43,166,94,0.55)') + '<div style="flex:1">' + slider(state.flushSec, 0, 9, 0.1, 'flushSec', 'sec') + '</div></div></div>' +
      '</div>', true);
  }

  function statusHTML(state) {
    function cartBtn(key, added) {
      return '<button type="button" data-reorder="' + key + '" style="width:42px;height:42px;border-radius:11px;flex-shrink:0;background:' + (added ? C.sodaB : 'rgba(44,107,246,0.16)') + ';border:1px solid ' + (added ? C.sodaB : 'rgba(44,107,246,0.4)') + ';display:grid;place-items:center;cursor:pointer;transition:all 200ms;-webkit-tap-highlight-color:transparent">' + I(added ? 'check' : 'cart', 18, added ? '#fff' : '#5B8DF8', 1.8) + '</button>';
    }
    function row(inner, glyph) {
      return '<div style="display:flex;align-items:center;gap:16px;padding:18px 0">' + inner + '<div style="margin-left:auto;display:grid;place-items:center;width:60px">' + glyph + '</div></div>';
    }
    function label(t) { return '<div style="color:' + C.mute + ';font-size:12px;font-weight:600;letter-spacing:1.4px;margin-top:16px">' + t + '</div>'; }
    return shell(
      head('System Status', true) +
      '<div style="padding-top:4px;font-family:' + FONT + '">' +
      '<div style="color:' + C.mute + ';font-size:12px;font-weight:600;letter-spacing:1.4px;margin-top:10px">CO₂</div>' +
      row(cartBtn('co2', state.cart.co2) + '<div><div style="color:' + C.white + ';font-size:16px;font-weight:500">Kulsyrepatron</div><div style="color:' + C.mute + ';font-size:13px;margin-top:2px">Niveau: Medium</div><div style="color:' + C.faint + ';font-size:12px;margin-top:1px">~ 28 L brus tilbage</div></div>', co2Cylinder(0.62)) +
      '<div style="height:1px;background:' + C.hair + '"></div>' +
      label('FILTER') +
      row(cartBtn('filter', state.cart.filter) + '<div><div style="color:' + C.white + ';font-size:16px;font-weight:500">BWT-MyAqua</div><div style="color:' + C.mute + ';font-size:13px;margin-top:2px">99% tilbage</div><div style="color:' + C.faint + ';font-size:12px;margin-top:1px">Skift inden 17/01/2025</div></div>', filterGlyph(99)) +
      '<div style="height:1px;background:' + C.hair + '"></div>' +
      label('DESINFEKTION') +
      row(cartBtn('desinfekt', state.cart.desinfekt) + '<div><div style="color:' + C.white + ';font-size:16px;font-weight:500">Desinfektion</div><div style="color:' + C.mute + ';font-size:13px;margin-top:2px">Forfalder om</div><div style="color:' + C.white + ';font-size:22px;font-weight:300;margin-top:1px">183 <span style="font-size:13px;color:' + C.mute + '">dage</span></div></div>', bottleGlyph()) +
      '</div>', true);
  }

  /* ---------- montering + adfærd ---------- */
  function mount(container) {
    var state = loadState();
    var screen = 'home';
    container.innerHTML = frameHTML();
    var app = container.querySelector('[data-anywhere-app]');

    function set(key, val) { state[key] = val; persist(state); }

    function render() {
      if (screen === 'home') app.innerHTML = homeHTML(state);
      else if (screen === 'cold' || screen === 'hot') app.innerHTML = tempScreenHTML(screen, state);
      else if (screen === 'soda') app.innerHTML = sodaHTML(state);
      else if (screen === 'faucet') app.innerHTML = faucetHTML(state);
      else if (screen === 'status') app.innerHTML = statusHTML(state);
      bind();
    }

    function updateGauge() {
      var isCold = screen === 'cold';
      var v = isCold ? state.cold : state.hot;
      var min = isCold ? 5 : 60, max = isCold ? 12 : 100;
      var frac = isCold ? (max - v) / (max - min) : (v - min) / (max - min);
      var prog = app.querySelector('[data-g-prog]');
      if (prog) {
        var arc = parseFloat(prog.getAttribute('data-g-arc'));
        var circ = parseFloat(prog.getAttribute('data-g-circ'));
        prog.setAttribute('stroke-dasharray', (Math.max(0, Math.min(1, frac)) * arc) + ' ' + circ);
      }
      var val = app.querySelector('[data-g-val]'); if (val) val.textContent = v;
      var foot = app.querySelector('[data-foot-val]'); if (foot) foot.textContent = v + '°';
      var minus = app.querySelector('[data-step="-1"]'), plus = app.querySelector('[data-step="1"]');
      if (minus) styleStep(minus, v <= min);
      if (plus) styleStep(plus, v >= max);
    }
    function updateSoda() {
      var cur = SODA_LEVELS[state.soda];
      var needle = app.querySelector('[data-needle]');
      if (needle) {
        var r = parseFloat(needle.getAttribute('data-r'));
        var cx = parseFloat(needle.getAttribute('data-cx'));
        var cy = parseFloat(needle.getAttribute('data-cy'));
        var rad = (135 + cur.frac * 270) * Math.PI / 180;
        needle.setAttribute('x2', cx + r * Math.cos(rad));
        needle.setAttribute('y2', cy + r * Math.sin(rad));
      }
      var lab = app.querySelector('[data-soda-label]'); if (lab) lab.textContent = cur.label;
      var minus = app.querySelector('[data-step="-1"]'), plus = app.querySelector('[data-step="1"]');
      if (minus) styleStep(minus, state.soda <= 0);
      if (plus) styleStep(plus, state.soda >= 2);
    }
    function styleStep(btn, disabled) {
      btn.disabled = disabled;
      btn.style.opacity = disabled ? '0.4' : '1';
      btn.style.borderColor = disabled ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.28)';
      btn.style.cursor = disabled ? 'default' : 'pointer';
    }

    function bind() {
      app.querySelectorAll('[data-go]').forEach(function (b) {
        b.addEventListener('click', function () { screen = b.getAttribute('data-go'); render(); });
      });
      app.querySelectorAll('[data-back]').forEach(function (b) {
        b.addEventListener('click', function () { screen = 'home'; render(); });
      });
      app.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          var dir = parseInt(b.getAttribute('data-step'), 10);
          if (screen === 'cold') { set('cold', Math.max(5, Math.min(12, state.cold + dir))); updateGauge(); }
          else if (screen === 'hot') { set('hot', Math.max(60, Math.min(100, state.hot + dir))); updateGauge(); }
          else if (screen === 'soda') { set('soda', Math.max(0, Math.min(2, state.soda + dir))); updateSoda(); }
        });
        b.addEventListener('pointerdown', function () { if (!b.disabled) b.style.background = 'rgba(255,255,255,0.08)'; });
        b.addEventListener('pointerup', function () { b.style.background = 'transparent'; });
        b.addEventListener('pointerleave', function () { b.style.background = 'transparent'; });
      });
      app.querySelectorAll('[data-seg]').forEach(function (seg) {
        var key = seg.getAttribute('data-seg');
        seg.querySelectorAll('[data-seg-val]').forEach(function (b) {
          b.addEventListener('click', function () {
            set(key, b.getAttribute('data-seg-val'));
            seg.querySelectorAll('[data-seg-val]').forEach(function (x) {
              var on = x === b;
              x.style.background = on ? C.blue : 'transparent';
              x.style.color = on ? '#fff' : C.mute;
            });
          });
        });
      });
      app.querySelectorAll('[data-slider]').forEach(function (wrap) {
        var key = wrap.getAttribute('data-slider');
        var min = parseFloat(wrap.getAttribute('data-min'));
        var max = parseFloat(wrap.getAttribute('data-max'));
        var input = wrap.querySelector('input');
        var valEl = wrap.querySelector('[data-slider-val]');
        var suffixHTML = valEl.querySelector('span').outerHTML;
        input.addEventListener('input', function () {
          var v = parseFloat(input.value);
          if (key === 'flushSec') v = Math.round(v * 10) / 10;
          set(key, v);
          valEl.innerHTML = v + suffixHTML;
          var frac = (v - min) / (max - min);
          input.style.background = 'linear-gradient(90deg,' + C.blue + ' ' + (frac * 100) + '%,rgba(255,255,255,0.14) ' + (frac * 100) + '%)';
        });
      });
      app.querySelectorAll('[data-reorder]').forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.getAttribute('data-reorder');
          if (state.cart[key]) return;
          state.cart[key] = true;
          b.style.background = C.sodaB; b.style.borderColor = C.sodaB;
          b.innerHTML = I('check', 18, '#fff', 1.8);
          setTimeout(function () {
            state.cart[key] = false;
            b.style.background = 'rgba(44,107,246,0.16)'; b.style.borderColor = 'rgba(44,107,246,0.4)';
            b.innerHTML = I('cart', 18, '#5B8DF8', 1.8);
          }, 1800);
        });
      });
    }

    render();
  }

  function init() {
    document.querySelectorAll('[data-anywhere-mount]').forEach(function (el) { mount(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.UnitoAnywhere = { mount: mount };
})();
